import { render, staticRenderFns } from "./sysConfig.vue?vue&type=template&id=f8343a08&scoped=true&"
import script from "./sysConfig.vue?vue&type=script&lang=js&"
export * from "./sysConfig.vue?vue&type=script&lang=js&"
import style0 from "./sysConfig.vue?vue&type=style&index=0&id=f8343a08&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8343a08",
  null
  
)

export default component.exports